import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/churn")({
    beforeLoad: () => {
        throw redirect({ to: "/customers/churn", replace: true });
    },
});
